import { useState, useMemo } from 'react'
import { TimeRange, getTimeRangeFromFilter } from '@/components/activities/TimeRangeUtils'

export interface ActivityFiltersState {
  tabValue: 'all' | 'sleep' | 'nap' | 'feeding'
  timeFilter: 'all' | 'today' | 'week' | 'month'
  searchQuery: string
  timeRange: TimeRange | null
}

export interface ActivityFiltersActions {
  setTabValue: (value: 'all' | 'sleep' | 'nap' | 'feeding') => void
  setTimeFilter: (value: 'all' | 'today' | 'week' | 'month') => void
  setSearchQuery: (value: string) => void
}

/**
 * Hook to manage activity filters state
 */
export function useActivityFilters(): ActivityFiltersState & ActivityFiltersActions {
  const [tabValue, setTabValue] = useState<'all' | 'sleep' | 'nap' | 'feeding'>('all')
  const [timeFilter, setTimeFilter] = useState<'all' | 'today' | 'week' | 'month'>('today')
  const [searchQuery, setSearchQuery] = useState('')
  
  // Calculate time range when filter changes
  const timeRange = useMemo(() => getTimeRangeFromFilter(timeFilter), [timeFilter])
  
  return {
    tabValue,
    timeFilter,
    searchQuery,
    timeRange,
    setTabValue,
    setTimeFilter,
    setSearchQuery
  }
}
